var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCardLinearGradient = function SvgCardLinearGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#CardLinearGradient_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.95 11.9H1.05A1.05 1.05 0 0 1 0 10.85v-7.7A1.05 1.05 0 0 1 1.05 2.1h11.9A1.05 1.05 0 0 1 14 3.15v7.7a1.05 1.05 0 0 1-1.05 1.05ZM1.05 2.8a.35.35 0 0 0-.35.35v7.7a.35.35 0 0 0 .35.35h11.9a.35.35 0 0 0 .35-.35v-7.7a.35.35 0 0 0-.35-.35H1.05Z",
    fill: "url(#CardLinearGradient_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.95 11.9H1.05A1.05 1.05 0 0 1 0 10.85v-7.7A1.05 1.05 0 0 1 1.05 2.1h11.9A1.05 1.05 0 0 1 14 3.15v7.7a1.05 1.05 0 0 1-1.05 1.05ZM1.05 2.8a.35.35 0 0 0-.35.35v7.7a.35.35 0 0 0 .35.35h11.9a.35.35 0 0 0 .35-.35v-7.7a.35.35 0 0 0-.35-.35H1.05Z",
    fill: "url(#CardLinearGradient_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.65 4.2H.35a.35.35 0 0 1 0-.7h13.3a.35.35 0 0 1 0 .7Z",
    fill: "url(#CardLinearGradient_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.65 6.3H.35a.35.35 0 0 1 0-.7h13.3a.35.35 0 0 1 0 .7Z",
    fill: "url(#CardLinearGradient_svg__e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.95 8.4h-3.5a.35.35 0 1 1 0-.7h3.5a.35.35 0 0 1 0 .7Z",
    fill: "url(#CardLinearGradient_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.55 9.8h-2.1a.35.35 0 0 1 0-.7h2.1a.35.35 0 0 1 0 .7Z",
    fill: "url(#CardLinearGradient_svg__g)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "CardLinearGradient_svg__b",
    x1: 0,
    y1: 7,
    x2: 14,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "#03C8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "#5C7AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CardLinearGradient_svg__c",
    x1: 0,
    y1: 7,
    x2: 14,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "#03C8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "#5C7AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CardLinearGradient_svg__d",
    x1: 0,
    y1: 3.85,
    x2: 14,
    y2: 3.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "#03C8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "#5C7AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CardLinearGradient_svg__e",
    x1: 0,
    y1: 5.95,
    x2: 14,
    y2: 5.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "#03C8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "#5C7AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CardLinearGradient_svg__f",
    x1: 2.1,
    y1: 8.049,
    x2: 6.3,
    y2: 8.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "#03C8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "#5C7AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CardLinearGradient_svg__g",
    x1: 2.1,
    y1: 9.45,
    x2: 4.9,
    y2: 9.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "#03C8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "#5C7AFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "CardLinearGradient_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};

export default SvgCardLinearGradient;